/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * User account type
 */
export type SignUpRequestAccountType = typeof SignUpRequestAccountType[keyof typeof SignUpRequestAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignUpRequestAccountType = {
  PERSONAL: 'PERSONAL',
  CORPORATE: 'CORPORATE',
} as const;
